import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { GrView } from "react-icons/gr";
import { MdDownload } from "react-icons/md";
import jsPDF from "jspdf";
import * as XLSX from 'xlsx';
 import "jspdf-autotable";
 import { FaStar, FaRegStar } from "react-icons/fa"
import { useCookies } from "react-cookie";
import { MdDelete } from "react-icons/md";

const CandidateDetailPage = () => {
  const { userid } = useParams(); 
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [loading, setLoading] = useState(true);  
  const [error, setError] = useState(null);  
  const [feedbacks, setFeedbacks] = useState([]);
    // const [loading, setLoading] = useState(true);
     const [cookies,setCookie, removeCookie] = useCookies(["authToken", "userName", "role", "team"]);

  useEffect(() => {
    fetchCandidateDetails();
  }, [userid]);

  const fetchCandidateDetails = async () => {
    setLoading(true);  
    setError(null);    
    try {
      const response = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/candidate/${userid}`);
      if (!response.ok) throw new Error("Failed to fetch candidate details");
      const data = await response.json();
      // console.log(data,"dddddddddddttt");
      
      setCandidateDetails(data);  
    } catch (error) {
      setError(error.message);  
    } finally {
      setLoading(false);  
    }
  };




const deleteQualification = async (qualificationId) => {

  
  try {
    const response = await fetch(
      `  http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/Qualification/${qualificationId}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response.ok) throw new Error("Failed to delete qualification");
    const data = await response.json();

    alert(data.message);
    fetchCandidateDetails();
     // Refetch the qualifications after deletion
  } catch (error) {
    console.error("Error deleting qualification:", error);
  }

}


const deleteFamilyDetails= async (familyDetailsId) => {

  console.log(familyDetailsId,"qqqqqqqqqq");
  try {
    const response = await fetch(
      `  http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/FamilyDetails/${familyDetailsId}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response.ok) throw new Error("Failed to delete FamilyDetails");
    const data = await response.json();

    alert(data.message);
    fetchCandidateDetails();
     // Refetch the FamilyDetailss after deletion
  } catch (error) {
    console.error("Error deleting FamilyDetails:", error);
  }


    }


    const deleteEmergencyDetails = async (emergencyDetailsId) => {

     
      try {
        const response = await fetch(
          `  http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/EmergencyDetails/${emergencyDetailsId}`,
          {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
          })
          if (!response.ok) throw new Error("Failed to delete EmergencyDetails");
          const data = await response.json();

          alert(data.message);
          fetchCandidateDetails();
           // Refetch the EmergencyDetailss after deletion

    }catch (error) {
      console.error("Error deleting EmergencyDetails:", error);

    }}



    const deleteAdditionalInformation = async (additionalInformationId) => {
      
      try {
        const response = await fetch(
          `  http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/AdditionalInformation/${additionalInformationId}`,
          {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
          })
          if (!response.ok) throw new Error("Failed to delete AdditionalInformation");
          const data = await response.json();

          alert(data.message);
          fetchCandidateDetails();
           // Refetch the AdditionalInformations after deletion
    }catch (error) {
      console.error("Error deleting AdditionalInformation:", error);


    }
  }


  const deleteDocments = async (DocumentsId) => {
    console.log(DocumentsId,"qqqqqqqqqq");

    try {
      const response = await fetch(
        `  http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/Documents/${DocumentsId}`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
        })
        if (!response.ok) throw new Error("Failed to delete Documents");
        const data = await response.json();

        alert(data.message);
        fetchCandidateDetails();
         // Refetch the Documents after deletion
    
  }catch (error) {
    console.error("Error deleting Documents:", error);

  }}


  const deletePreviousExperience =async(previousExperienceId)=>{
    console.log( previousExperienceId,"iiiiii");

    try {
      const response=await fetch(` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/previousExperience/${previousExperienceId}`,{

        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      })
      if (!response.ok) throw new Error("Failed to delete previousExperience");
        const data = await response.json();

        alert(data.message);
        fetchCandidateDetails();
         // Refetch the previousExperience after deletion
      
    } catch (error) {
      console.error("Error deleting previousExperience:", error);

      
    }
    
  }


  const downloadImage = (fileUrl, fileName) => {
    const fileExtension = fileUrl.split('.').pop().toLowerCase();
  
    if (fileExtension === 'pdf') {
      // Directly download the PDF
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = fileName + '.pdf';
      link.click();
    } else {
      // Handle image download (PNG, JPEG, etc.)
      const doc = new jsPDF();
  
      fetch(fileUrl, { mode: "cors" })
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onload = function () {
            const imgData = reader.result;
  
            // Calculate PDF dimensions to fit the image
            const pdfWidth = doc.internal.pageSize.getWidth() - 20; // Margin
            const pdfHeight = doc.internal.pageSize.getHeight() - 20; // Margin
  
            const img = new Image();
            img.src = imgData;
            img.onload = () => {
              const imgWidth = img.width;
              const imgHeight = img.height;
              const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
              const width = imgWidth * ratio;
              const height = imgHeight * ratio;
  
              // Add the image to the PDF and save
              doc.addImage(imgData, "JPEG", 10, 10, width, height);
              doc.save(fileName + '.pdf');
            };
          };
          reader.readAsDataURL(blob); // Convert blob to base64
        })
        .catch((error) => {
          console.error("Image fetch error:", error);
        });
    }
  };
  


 
  
  const downloadPDF = () => {
    const doc = new jsPDF();
  
    // Step 1: Candidate Profile Picture and Details
    const imageUrl = candidateDetails?.user?.imageUrl || ' http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/default-image-url.jpg'; // Fallback image URL
    const fileName = "candidate_details"; // File name for the downloaded PDF
  
    // Add Profile Picture to the PDF
    fetch(imageUrl, { mode: "cors" })
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onload = function () {
          const imgData = reader.result;
  
          // Add the image to the PDF
          const pdfWidth = doc.internal.pageSize.getWidth();
          const pdfHeight = doc.internal.pageSize.getHeight();
  
          // Add the profile image
          doc.addImage(imgData, 'JPEG', 10, 10, 40, 40); // Position and size of the profile image
  
          // Step 2: Add Candidate Details (Text)
          doc.setFontSize(16);
          doc.setTextColor(0, 102, 204); // Blue color for titles
          doc.text('Candidate Details', 60, 20);
          doc.setFontSize(12);
          doc.setTextColor(0, 0, 0); // Black color for text
  
          // Create Table for Candidate Details
          const candidateData = [
            ["Field", "Details"],
            ["Name", `${candidateDetails?.user?.personalDetailsId?.name} ${candidateDetails?.user?.personalDetailsId?.LastName}`],
            ["Email", candidateDetails?.user?.personalDetailsId?.email],
            ["Contact", candidateDetails?.user?.personalDetailsId?.Contact],
            ["Date of Birth", new Date(candidateDetails?.user?.personalDetailsId?.dob).toLocaleDateString()],
          ];
  
          doc.autoTable({
            head: candidateData.slice(0, 1),
            body: candidateData.slice(1),
            startY: 30,
            margin: { left: 10, right: 10 },
            styles: {
              fontSize: 12,
              cellPadding: 5,
              overflow: 'linebreak',
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              halign: 'left',
            },
          });
  
          // Step 3: Add Qualification Details in Table Form
          doc.addPage(); // New page for Qualification Details
          doc.setFontSize(16);
          doc.setTextColor(0, 102, 204);
          doc.text('Qualification Details', 10, 10);
  
          const qualificationsData = [
            ["Qualification", "University/Institute", "Marks%", "Specialization", "Year of Passing"],
            [candidateDetails?.user?.qualificationId?.PostGradugationQualification, 
             candidateDetails?.user?.qualificationId?.PostGradugationQualification_University, 
             candidateDetails?.user?.qualificationId?.PostGradugationQualification_Marks,
             candidateDetails?.user?.qualificationId?.PostGradugationQualification_Specalization,
             candidateDetails?.user?.qualificationId?.PostGradugationQualification_Year_Of_Passing],
            
            [candidateDetails?.user?.qualificationId?.HigestQualification,
             candidateDetails?.user?.qualificationId?.HQualification_University,
             candidateDetails?.user?.qualificationId?.HQualification_Marks,
             candidateDetails?.user?.qualificationId?.HQualification_Specalization,
             candidateDetails?.user?.qualificationId?.HQualification_Year_Of_Passing],
  
            [candidateDetails?.user?.qualificationId?.MiddleQualification,
             candidateDetails?.user?.qualificationId?.MQualification_University,
             candidateDetails?.user?.qualificationId?.MQualification_Marks,
             candidateDetails?.user?.qualificationId?.MQualification_Specalization,
             candidateDetails?.user?.qualificationId?.MQualification_Year_Of_Passing],
  
            [candidateDetails?.user?.qualificationId?.LowerQualification,
             candidateDetails?.user?.qualificationId?.LQualification_University,
             candidateDetails?.user?.qualificationId?.LQualification_Marks,
             candidateDetails?.user?.qualificationId?.LQualification_Specalization,
             candidateDetails?.user?.qualificationId?.LQualification_Year_Of_Passing],
          ];
  
          doc.autoTable({
            head: qualificationsData.slice(0, 1),
            body: qualificationsData.slice(1),
            startY: 20,
            margin: { left: 10, right: 10 },
            styles: {
              fontSize: 12,
              cellPadding: 5,
              overflow: 'linebreak',
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              halign: 'left',
              valign: 'middle',
            },
          });
  
          // Step 4: Add Family Details in Table Form
          doc.addPage(); // New page for Family Details
          doc.setFontSize(16);
          doc.setTextColor(0, 102, 204);
          doc.text('Family Details', 10, 10);
  
          const familyDetailsData = [
            ["Name", "Age", "Relation", "Occupation"],
            [candidateDetails?.user?.familyDetailsId?.Fname, 
             candidateDetails?.user?.familyDetailsId?.Fage, 
             candidateDetails?.user?.familyDetailsId?.Frelation,
             candidateDetails?.user?.familyDetailsId?.Foccupation],
  
            [candidateDetails?.user?.familyDetailsId?.Sname, 
             candidateDetails?.user?.familyDetailsId?.Sage, 
             candidateDetails?.user?.familyDetailsId?.Srelation,
             candidateDetails?.user?.familyDetailsId?.Soccupation],
  
            [candidateDetails?.user?.familyDetailsId?.Tname, 
             candidateDetails?.user?.familyDetailsId?.Tage, 
             candidateDetails?.user?.familyDetailsId?.Trelation,
             candidateDetails?.user?.familyDetailsId?.Toccupation],
  
            [candidateDetails?.user?.familyDetailsId?.ForthName, 
             candidateDetails?.user?.familyDetailsId?.ForthAge, 
             candidateDetails?.user?.familyDetailsId?.ForthRelation,
             candidateDetails?.user?.familyDetailsId?.ForthOccupation],
          ];
  
          doc.autoTable({
            head: familyDetailsData.slice(0, 1),
            body: familyDetailsData.slice(1),
            startY: 20,
            margin: { left: 10, right: 10 },
            styles: {
              fontSize: 12,
              cellPadding: 5,
              overflow: 'linebreak',
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              halign: 'left',
              valign: 'middle',
            },
          });
  
          // Step 5: Add Previous Experience Details
          doc.addPage();
          doc.setFontSize(16);
          doc.setTextColor(0, 102, 204);
          doc.text('Previous Experience Details', 10, 10);
  
          const experienceData = [
            ["Organisation", "Period (From - To)", "Designation", "Previous HR/Manager Name", "Designation Superior", "Last Salary", "Reason For Leaving"],
            [user?.previousExperienceId?.organisation,
             `${user?.previousExperienceId?.period_from} - ${user?.previousExperienceId?.period_to}`,
             user?.previousExperienceId?.designation,
             user?.previousExperienceId?.name,
             user?.previousExperienceId?.Superior_Email_Id,
             user?.previousExperienceId?.last_salary,
             user?.previousExperienceId?.reason_for_leaving],
  
            [user?.previousExperienceId?.Second_organisation,
             `${user?.previousExperienceId?.Second_period_from} - ${user?.previousExperienceId?.Second_period_to}`,
             user?.previousExperienceId?.Second_designation,
             user?.previousExperienceId?.Second_name,
             user?.previousExperienceId?.Second_Superior_Email_Id,
             user?.previousExperienceId?.Second_last_salary,
             user?.previousExperienceId?.Second_reason_for_leaving],
  
            [user?.previousExperienceId?.third_organisation,
             `${user?.previousExperienceId?.third_period_from} - ${user?.previousExperienceId?.third_period_to}`,
             user?.previousExperienceId?.third_designation,
             user?.previousExperienceId?.third_name,
             user?.previousExperienceId?.third_Superior_Email_Id,
             user?.previousExperienceId?.third_last_salary,
             user?.previousExperienceId?.third_reason_for_leaving],
  
            [user?.previousExperienceId?.four_organisation,
             `${user?.previousExperienceId?.four_period_from} - ${user?.previousExperienceId?.four_period_to}`,
             user?.previousExperienceId?.four_designation,
             user?.previousExperienceId?.four_name,
             user?.previousExperienceId?.four_Superior_Email_Id,
             user?.previousExperienceId?.four_last_salary,
             user?.previousExperienceId?.four_reason_for_leaving],
          ];
  
          doc.autoTable({
            head: experienceData.slice(0, 1),
            body: experienceData.slice(1),
            startY: 20,
            margin: { left: 10, right: 10 },
            styles: {
              fontSize: 12,
              cellPadding: 5,
              overflow: 'linebreak',
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              halign: 'left',
              valign: 'middle',
            },
          });
  
          // Step 6: Add Emergency Details
          doc.addPage();
          doc.setFontSize(16);
          doc.setTextColor(0, 102, 204);
          doc.text('Emergency Details', 10, 10);
  
          const emergencyData = [
            ["Contact Person Name", "Emergency Contact Person", "Blood Group"],
            [user?.emergencyDetailsId?.Contact_Person_Name,
             user?.emergencyDetailsId?.Contact_Person_in_case_of_Emergency,
             user?.emergencyDetailsId?.Blood_Group],
          ];
  
          doc.autoTable({
            head: emergencyData.slice(0, 1),
            body: emergencyData.slice(1),
            startY: 20,
            margin: { left: 10, right: 10 },
            styles: {
              fontSize: 12,
              cellPadding: 5,
              overflow: 'linebreak',
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              halign: 'left',
            },
          });
  
          // Step 7: Add Additional Information
          doc.addPage();
          doc.setFontSize(16);
          doc.setTextColor(0, 102, 204);
          doc.text('Additional Information', 10, 10);
  
          const additionalData = [
            ["Physical Disabilities", user?.additionalInformationId?.Physical_Disabilities],
            ["Marital Indebtness", user?.additionalInformationId?.Marital_Indebtness],
            ["Involvement in Court Proceedings", user?.additionalInformationId?.Been_involved_in_Court_Proceeding],
            ["Languages Known", user?.additionalInformationId?.Languages_Known],
            ["Hobbies", user?.additionalInformationId?.Hobbies],
            ["Your Three Weaknesses", user?.additionalInformationId?.Three_Strengths],
            ["Your Three Strengths", user?.additionalInformationId?.three_Weaknesses],
            ["Are you willing to travel in India?", user?.additionalInformationId?.In_India],
            ["Are you willing to travel abroad?", user?.additionalInformationId?.Abroad],
          ];
  
          doc.autoTable({
            head: additionalData.slice(0, 1),
            body: additionalData.slice(1),
            startY: 20,
            margin: { left: 10, right: 10 },
            styles: {
              fontSize: 12,
              cellPadding: 5,
              overflow: 'linebreak',
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
              halign: 'left',
            },
          });
  
          // Step 8: Save the PDF with all tables
          doc.save(`${fileName}.pdf`);
        };
        reader.readAsDataURL(blob); // Convert the image to base64
      })
      .catch((error) => {
        console.error("Image fetch error:", error);
      });
  };

  
  

  const downloadExcel = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // Step 1: Candidate Profile Picture and Details
    const candidateDetailsSheet = [
      ["Field", "Details"],
      ["Name", `${candidateDetails?.user?.personalDetailsId?.name} ${candidateDetails?.user?.personalDetailsId?.LastName}`],
      ["Email", candidateDetails?.user?.personalDetailsId?.email],
      ["Contact", candidateDetails?.user?.personalDetailsId?.Contact],
      ["Date of Birth", new Date(candidateDetails?.user?.personalDetailsId?.dob).toLocaleDateString()],
    ];
  
    // Add candidate details sheet
    const ws1 = XLSX.utils.aoa_to_sheet(candidateDetailsSheet);
    XLSX.utils.book_append_sheet(wb, ws1, "Candidate Details");
  
    // Step 2: Add Qualification Details
    const qualificationsSheet = [
      ["Qualification", "University/Institute", "Marks%", "Specialization", "Year of Passing"],
      [candidateDetails?.user?.qualificationId?.PostGradugationQualification, 
       candidateDetails?.user?.qualificationId?.PostGradugationQualification_University, 
       candidateDetails?.user?.qualificationId?.PostGradugationQualification_Marks,
       candidateDetails?.user?.qualificationId?.PostGradugationQualification_Specalization,
       candidateDetails?.user?.qualificationId?.PostGradugationQualification_Year_Of_Passing],
      
      [candidateDetails?.user?.qualificationId?.HigestQualification,
       candidateDetails?.user?.qualificationId?.HQualification_University,
       candidateDetails?.user?.qualificationId?.HQualification_Marks,
       candidateDetails?.user?.qualificationId?.HQualification_Specalization,
       candidateDetails?.user?.qualificationId?.HQualification_Year_Of_Passing],
    
      [candidateDetails?.user?.qualificationId?.MiddleQualification,
       candidateDetails?.user?.qualificationId?.MQualification_University,
       candidateDetails?.user?.qualificationId?.MQualification_Marks,
       candidateDetails?.user?.qualificationId?.MQualification_Specalization,
       candidateDetails?.user?.qualificationId?.MQualification_Year_Of_Passing],
    
      [candidateDetails?.user?.qualificationId?.LowerQualification,
       candidateDetails?.user?.qualificationId?.LQualification_University,
       candidateDetails?.user?.qualificationId?.LQualification_Marks,
       candidateDetails?.user?.qualificationId?.LQualification_Specalization,
       candidateDetails?.user?.qualificationId?.LQualification_Year_Of_Passing],
    ];
  
    // Add qualification details sheet
    const ws2 = XLSX.utils.aoa_to_sheet(qualificationsSheet);
    XLSX.utils.book_append_sheet(wb, ws2, "Qualification Details");
  
    // Step 3: Add Family Details
    const familyDetailsSheet = [
      ["Name", "Age", "Relation", "Occupation"],
      [candidateDetails?.user?.familyDetailsId?.Fname, 
       candidateDetails?.user?.familyDetailsId?.Fage, 
       candidateDetails?.user?.familyDetailsId?.Frelation,
       candidateDetails?.user?.familyDetailsId?.Foccupation],
    
      [candidateDetails?.user?.familyDetailsId?.Sname, 
       candidateDetails?.user?.familyDetailsId?.Sage, 
       candidateDetails?.user?.familyDetailsId?.Srelation,
       candidateDetails?.user?.familyDetailsId?.Soccupation],
    
      [candidateDetails?.user?.familyDetailsId?.Tname, 
       candidateDetails?.user?.familyDetailsId?.Tage, 
       candidateDetails?.user?.familyDetailsId?.Trelation,
       candidateDetails?.user?.familyDetailsId?.Toccupation],
    
      [candidateDetails?.user?.familyDetailsId?.ForthName, 
       candidateDetails?.user?.familyDetailsId?.ForthAge, 
       candidateDetails?.user?.familyDetailsId?.ForthRelation,
       candidateDetails?.user?.familyDetailsId?.ForthOccupation],
    ];
  
    // Add family details sheet
    const ws3 = XLSX.utils.aoa_to_sheet(familyDetailsSheet);
    XLSX.utils.book_append_sheet(wb, ws3, "Family Details");
  
    // Step 4: Add Previous Experience
    const previousExperienceSheet = [
      ["Organisation", "Period (From - To)", "Designation", "Previous HR/Manager Name", "Designation Superior", "Last Salary", "Reason For Leaving"],
      [user?.previousExperienceId?.organisation, `${user?.previousExperienceId?.period_from} - ${user?.previousExperienceId?.period_to}`, user?.previousExperienceId?.designation, user?.previousExperienceId?.name, user?.previousExperienceId?.Superior_Email_Id, user?.previousExperienceId?.last_salary, user?.previousExperienceId?.reason_for_leaving],
      [user?.previousExperienceId?.Second_organisation, `${user?.previousExperienceId?.Second_period_from} - ${user?.previousExperienceId?.Second_period_to}`, user?.previousExperienceId?.Second_designation, user?.previousExperienceId?.Second_name, user?.previousExperienceId?.Second_Superior_Email_Id, user?.previousExperienceId?.Second_last_salary, user?.previousExperienceId?.Second_reason_for_leaving],
      [user?.previousExperienceId?.third_organisation, `${user?.previousExperienceId?.third_period_from} - ${user?.previousExperienceId?.third_period_to}`, user?.previousExperienceId?.third_designation, user?.previousExperienceId?.third_name, user?.previousExperienceId?.third_Superior_Email_Id, user?.previousExperienceId?.third_last_salary, user?.previousExperienceId?.third_reason_for_leaving],
      [user?.previousExperienceId?.four_organisation, `${user?.previousExperienceId?.four_period_from} - ${user?.previousExperienceId?.four_period_to}`, user?.previousExperienceId?.four_designation, user?.previousExperienceId?.four_name, user?.previousExperienceId?.four_Superior_Email_Id, user?.previousExperienceId?.four_last_salary, user?.previousExperienceId?.four_reason_for_leaving],
    ];
  
    // Add previous experience sheet
    const ws4 = XLSX.utils.aoa_to_sheet(previousExperienceSheet);
    XLSX.utils.book_append_sheet(wb, ws4, "Previous Experience");
  
    // Step 5: Add Emergency Details
    const emergencyDetailsSheet = [
      ["Contact Person Name", "Emergency Contact Person", "Blood Group"],
      [user?.emergencyDetailsId?.Contact_Person_Name, user?.emergencyDetailsId?.Contact_Person_in_case_of_Emergency, user?.emergencyDetailsId?.Blood_Group],
    ];
  
    // Add emergency details sheet
    const ws5 = XLSX.utils.aoa_to_sheet(emergencyDetailsSheet);
    XLSX.utils.book_append_sheet(wb, ws5, "Emergency Details");
  
    // Step 6: Add Additional Information
    const additionalInfoSheet = [
      ["Physical Disabilities", user?.additionalInformationId?.Physical_Disabilities],
      ["Marital Indebtness", user?.additionalInformationId?.Marital_Indebtness],
      ["Involvement in Court Proceedings", user?.additionalInformationId?.Been_involved_in_Court_Proceeding],
      ["Languages Known", user?.additionalInformationId?.Languages_Known],
      ["Hobbies", user?.additionalInformationId?.Hobbies],
      ["Your Three Weaknesses", user?.additionalInformationId?.Three_Strengths],
      ["Your Three Strengths", user?.additionalInformationId?.three_Weaknesses],
      ["Are you willing to travel (In India)", user?.additionalInformationId?.In_India],
      ["Are you willing to travel (Abroad)", user?.additionalInformationId?.Abroad],
    ];
  
    // Add additional information sheet
    const ws6 = XLSX.utils.aoa_to_sheet(additionalInfoSheet);
    XLSX.utils.book_append_sheet(wb, ws6, "Additional Information");
  
    // Save the workbook
    XLSX.writeFile(wb, 'candidate_details.xlsx');
  };
  
  useEffect(() => {
    if (!userid) return;

    const fetchFeedback = async () => {
      try {
        const res = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/feedback/${userid}`);
        const data = await res.json();

        if (res.ok) {
          setFeedbacks(data);
        } else {
          console.error('Error fetching feedback:', data.message || data.error);
          setFeedbacks([]);
        }
      } catch (error) {
        console.error('Fetch error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeedback();
  }, [userid]);
  

const deleteDocument = async (field, userId, refreshCallback) => {
  try {
    const res = await fetch(
      `http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/documents/${field}/${userId}`,
      { method: "DELETE" }
    );
    if (res.ok) {
      alert(`${field} deleted successfully`);
      refreshCallback(); // refresh user data
    } else {
      const data = await res.json();
      alert(`Error: ${data.error}`);
    }
  } catch (err) {
    console.error(err);
    alert("Failed to delete document");
  }
};



const deleteWrongDocument = async (fieldName, userId) => {
  try {
    const response = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/delete-field/${userId}/${fieldName}`, {
      method: "DELETE",
    });

    const data = await response.json();

    if (response.ok) {
      alert(`${fieldName} deleted successfully`);
      // Optional: Update UI or reload
      window.location.reload(); // Or trigger a state update
    } else {
      alert(data.error || "Failed to delete document");
    }
  } catch (error) {
    console.error("Error deleting document:", error);
    alert("Server error while deleting document");
  }
};




  if (loading) {
    return <div className="text-center text-xl font-semibold text-gray-500">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-xl font-semibold text-red-600">Error: {error}</div>;
  }

  if (!candidateDetails) {
    return <div className="text-center text-xl font-semibold text-gray-500">No candidate details available</div>;
  }

  const { user, personalDetailsId, qualificationId, familyDetailsId,previousExperienceId, emergencyDetailsId, DocumentsId, additionalInformationId,status } = candidateDetails;

  return (
    <div className="container mx-auto p-6 bg-gray-100 rounded-lg shadow-lg">

<div className=" flex justify-between ">
  <h2 className="text-xl font-semibold text-blue-600 mb-4">Status: {status}</h2>
  <div className=" flex gap-2">
  <button onClick={downloadPDF}   className=" bg-green-600 text-white px-4 py-1 mb-4 ml-4 rounded-md justify-end"
   >Download PDF</button>
    <button onClick={downloadExcel}   className=" bg-green-600 text-white px-4 py-1 mb-4 ml-4 rounded-md justify-end"
   >Download Excel</button>

  </div>
  </div>



      <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">Candidate Details</h1>

    
    

  <div className="card bg-white p-6 mb-6 rounded-lg shadow-md">
  <h2 className="text-2xl font-semibold text-blue-700 mb-4">Personal Details</h2>

  <table className="min-w-full table-auto">
    <thead>
      <tr className="bg-gray-100">
        <th className="px-4 py-2 text-left text-gray-600">Field</th>
        <th className="border px-4 py-2 text-left text-gray-600">Details</th>
      </tr>
    </thead>
    <tbody>
      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">Profile Picture</td>
        <td className="px-4 py-2">
        {user?.personalDetailsId?.profilePic && (
  <img
    className="rounded-full w-32 h-32 object-cover"
    src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.personalDetailsId?.profilePic}`}
    alt="Profile"
  />
)}

        </td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">Name</td>
        <td className="px-4 py-2">{user?.personalDetailsId?.name}</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">Last Name</td>
        <td className="px-4 py-2">{user?.personalDetailsId?.LastName}</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">Email</td>
        <td className="px-4 py-2">{user?.personalDetailsId?.email}</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">Contact</td>
        <td className="px-4 py-2">{user?.personalDetailsId?.Contact}</td>
      </tr>
      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">Date of Birth</td>
        <td className="px-4 py-2">
  {user?.personalDetailsId?.dob ? new Date(user.personalDetailsId.dob).toLocaleDateString() : ""}
</td>

      </tr>
    </tbody>
  </table>
</div>



        {/* Qualification Details */}
        <div className="card bg-white p-6 mb-6 rounded-lg shadow-md">
  <div className=" flex justify-between ">
  <h2 className="text-xl font-semibold text-blue-600 mb-4">Qualification</h2>
  {cookies.role !== "67f7d873fa852258bf9a2112" && (
  <button onClick={()=>deleteQualification(user.qualificationId._id)}   className="bg-red-500 text-white px-4 py-1 mb-4 ml-4 rounded-md justify-end"
   >Delete</button> )}
  </div>

  <table className="min-w-full table-auto">
    <thead>
      <tr className="bg-gray-100">
        <th className="px-4 py-2 text-left text-gray-600">Qualification</th>
        <th className="border px-4 py-2 text-left">University/Institute</th>
        <th className="border px-4 py-2 text-left">Marks%</th>
        <th className="border px-4 py-2 text-left">Specialization</th>
        <th className="border px-4 py-2 text-left">Year of Passing </th>
      </tr>
    </thead>
    <tbody>
      <tr className="border-t">
      <td className="border px-4 py-2">{user?.qualificationId?.PostGradugationQualification}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.PostGradugationQualification_University}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.PostGradugationQualification_Marks}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.PostGradugationQualification_Specalization}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.PostGradugationQualification_Year_Of_Passing}</td>
      </tr>
      <tr>
      <td className="border px-4 py-2">{user?.qualificationId?.HigestQualification}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.HQualification_University}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.HQualification_Marks}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.HQualification_Specalization}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.HQualification_Year_Of_Passing}</td>
      </tr>

      <tr>
      <td className="border px-4 py-2">{user?.qualificationId?.MiddleQualification}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.MQualification_University}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.MQualification_Marks}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.MQualification_Specalization}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.MQualification_Year_Of_Passing}</td>
      </tr>

      <tr>
      <td className="border px-4 py-2">{user?.qualificationId?.LowerQualification}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.LQualification_University}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.LQualification_Marks}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.LQualification_Specalization}</td>
        <td className="border px-4 py-2">{user?.qualificationId?.LQualification_Year_Of_Passing}</td>
      </tr>
    </tbody>
  </table>
</div>




      {/* Family Details */}
      <div className="card bg-white p-6 mb-6 rounded-lg shadow-md">
 <div className="flex justify-between">
 <h2 className="text-xl font-semibold text-blue-600 mb-4">Family Details</h2>
 {cookies.role !== "67f7d873fa852258bf9a2112" && (
  <button onClick={()=>deleteFamilyDetails(user.familyDetailsId._id)}   className="bg-red-500 text-white px-4 py-1 mb-4 ml-4 rounded-md justify-end"
   >Delete</button>
  )}
 </div>

  <table className="min-w-full table-auto">
    <thead>
      <tr className="bg-gray-100">
        <th className="px-4 py-2 text-left text-gray-600">Name</th>
        <th className="px-4 py-2 text-left text-gray-600">Age</th>
        <th className="px-4 py-2 text-left text-gray-600">Relation</th>
        <th className="px-4 py-2 text-left text-gray-600">Occupation</th>
      </tr>
    </thead>
    <tbody>
      {/* Father Details */}
      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">{user?.familyDetailsId?.Fname}</td>
        <td className="px-4 py-2">{user?.familyDetailsId?.Fage}</td>
        <td className="px-4 py-2">{user?.familyDetailsId?.Frelation}</td>
        <td className="px-4 py-2">{user?.familyDetailsId?.Foccupation}</td>
      </tr>

      {/* Mother Details */}
      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">{user?.familyDetailsId?.Sname}</td>
        <td className="px-4 py-2">{user?.familyDetailsId?.Sage}</td>
        <td className="px-4 py-2">{user?.familyDetailsId?.Srelation}</td>  
        <td className="px-4 py-2">{user?.familyDetailsId?.Soccupation}</td>
      </tr>

      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">{user?.familyDetailsId?.Tname}</td>
        <td className="px-4 py-2">{user?.familyDetailsId?.Tage}</td>
        <td className="px-4 py-2">{user?.familyDetailsId?.Trelation}</td>  
        <td className="px-4 py-2">{user?.familyDetailsId?.Toccupation}</td>
      </tr>

      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">{user?.familyDetailsId?.ForthName}</td>
        <td className="px-4 py-2">{user?.familyDetailsId?.ForthAge}</td>
        <td className="px-4 py-2">{user?.familyDetailsId?.ForthRelation}</td>  
        <td className="px-4 py-2">{user?.familyDetailsId?.ForthOccupation}</td>
      </tr>


    </tbody>
  </table>
</div>





<div className="card bg-white p-6 mb-6 rounded-lg shadow-md">
      <div className=" flex justify-between ">
  <h2 className="text-xl font-semibold text-blue-600 mb-4">Previous Experience</h2>
  {cookies.role !== "67f7d873fa852258bf9a2112" && (
  <button onClick={()=>deletePreviousExperience(user?.previousExperienceId._id)}   className="bg-red-500 text-white px-4 py-1 mb-4 ml-4 rounded-md justify-end"
   >Delete</button>
  )}
  </div>

  <table className="min-w-full table-auto">
  <thead>
    <tr className="bg-gray-100">
      <th className="px-4 py-2 text-left text-gray-600">Organisation</th>
      <th className="px-4 py-2 text-left text-gray-600">Period (From - To)</th>
      <th className="px-4 py-2 text-left text-gray-600">Designation</th>
      <th className="px-4 py-2 text-left text-gray-600">Previous HR/Manager Name</th>
      <th className="px-4 py-2 text-left text-gray-600">Designation Superior of Email Id</th>
      <th className="px-4 py-2 text-left text-gray-600">Last Salary</th>
      <th className="px-4 py-2 text-left text-gray-600">Reason For Leaving</th>
    </tr>
  </thead>
  <tbody>
    <tr className="border-t">
      <td className="px-4 py-2 text-gray-600 font-semibold">{user?.previousExperienceId?.organisation}</td>
      
      {/* Combine Period From and Period To into one column */}
      <td className="px-4 py-2 text-gray-600">
        {user?.previousExperienceId?.period_from} - {user?.previousExperienceId?.period_to}
      </td>
      
      <td className="px-4 py-2">{user?.previousExperienceId?.designation}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.name}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.Superior_Email_Id}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.last_salary}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.reason_for_leaving}</td>
    </tr>

    <tr className="border-t">
      <td className="px-4 py-2 text-gray-600 font-semibold">{user?.previousExperienceId?.Second_organisation}</td>
      
      {/* Combine Period From and Period To into one column */}
      <td className="px-4 py-2 text-gray-600">
        {user?.previousExperienceId?.Second_period_from} - {user?.previousExperienceId?.Second_period_to}
      </td>
      
      <td className="px-4 py-2">{user?.previousExperienceId?.Second_designation}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.Second_name}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.Second_Superior_Email_Id}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.Second_last_salary}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.Second_reason_for_leaving}</td>
    </tr>

    <tr className="border-t">
      <td className="px-4 py-2 text-gray-600 font-semibold">{user?.previousExperienceId?.third_organisation}</td>
      
      {/* Combine Period From and Period To into one column */}
      <td className="px-4 py-2 text-gray-600">
        {user?.previousExperienceId?.third_period_from} - {user?.previousExperienceId?.third_period_to}
      </td>
      
      <td className="px-4 py-2">{user?.previousExperienceId?.third_designation}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.third_name}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.third_Superior_Email_Id}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.third_last_salary}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.third_reason_for_leaving}</td>
    </tr>

    <tr className="border-t">
      <td className="px-4 py-2 text-gray-600 font-semibold">{user?.previousExperienceId?.four_organisation}</td>
      
      {/* Combine Period From and Period To into one column */}
      <td className="px-4 py-2 text-gray-600">
        {user?.previousExperienceId?.four_period_from} - {user?.previousExperienceId?.four_period_to}
      </td>
      
      <td className="px-4 py-2">{user?.previousExperienceId?.four_designation}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.four_name}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.four_Superior_Email_Id}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.four_last_salary}</td>
      <td className="px-4 py-2">{user?.previousExperienceId?.four_reason_for_leaving}</td>
    </tr>


  </tbody>
</table>

</div>






      {/* Emergency Details */}
      <div className="card bg-white p-6 mb-6 rounded-lg shadow-md">
      <div className=" flex justify-between ">
  <h2 className="text-xl font-semibold text-blue-600 mb-4">Emergency Details</h2>
  {cookies.role !== "67f7d873fa852258bf9a2112" && (
  <button onClick={()=>deleteEmergencyDetails(user?.emergencyDetailsId._id)}   className="bg-red-500 text-white px-4 py-1 mb-4 ml-4 rounded-md justify-end"
   >Delete</button>
  )}
  </div>

  <table className="min-w-full table-auto">
    <thead>
      <tr className="bg-gray-100">
        <th className="px-4 py-2 text-left text-gray-600">Emergency Contact Person</th>
        <th className="px-4 py-2 text-left text-gray-600">Emergency Contact Number</th>
        <th className="px-4 py-2 text-left text-gray-600">Blood Group</th>
      </tr>
    </thead>
    <tbody>
      <tr className="border-t">
        <td className="px-4 py-2 text-gray-600 font-semibold">{user?.emergencyDetailsId?.Contact_Person_Name}</td>
        <td className="px-4 py-2">{user?.emergencyDetailsId?.Contact_Person_in_case_of_Emergency}</td>
        <td className="px-4 py-2">{user?.emergencyDetailsId?.Blood_Group}</td>
      </tr>
    </tbody>
  </table>
</div>


      {/* Additional Information */}
      <div className="card bg-white p-6 mb-6 rounded-lg shadow-md">
 
  <div className=" flex justify-between ">
  <h2 className="text-xl font-semibold text-blue-600 mb-4">Additional Information</h2>
  {cookies.role !== "67f7d873fa852258bf9a2112" && (
  <button onClick={()=>deleteAdditionalInformation(user?.additionalInformationId._id)}   className="bg-red-500 text-white px-4 py-1 mb-4 ml-4 rounded-md justify-end"
   >Delete</button>
  )}
  </div>
  
  <table className="min-w-full table-auto">
    <tbody>
      <tr className="border px-4 py-2 ">
        <td className="px-4 py-2 font-bold text-gray-600">Physical Disabilities:</td>
        <td className="px-4 py-2">{user?.additionalInformationId?.Physical_Disabilities}</td>
      </tr>
      <tr className="border px-4 py-2 mt-2">
        <td className="px-4 py-2 font-bold text-gray-600">Marital Indebtness:</td>
        <td className="px-4 py-2">{user?.additionalInformationId?.Marital_Indebtness}</td>
      </tr>
      <tr className="border px-4 py-2 mt-2">
        <td className="px-4 py-2 font-bold text-gray-600">Involvement in Court Proceedings:</td>
        <td className="px-4 py-2">{user?.additionalInformationId?.Been_involved_in_Court_Proceeding}</td>
      </tr>
      <tr className="border px-4 py-2 mt-2">
        <td className="px-4 py-2 font-bold text-gray-600">Languages Known:</td>
        <td className="px-4 py-2">{user?.additionalInformationId?.Languages_Known}</td>
      </tr>
      <tr className="border px-4 py-2 mt-2">
        <td className="px-4 py-2 font-bold text-gray-600">Hobbies:</td>
        <td className="px-4 py-2">{user?.additionalInformationId?.Hobbies}</td>
      </tr>
      <tr className="border px-4 py-2 mt-2">
        <td className="px-4 py-2 font-bold text-gray-600">Your Three Weaknesses:</td>
        <td className="px-4 py-2">{user?.additionalInformationId?.three_Weaknesses}</td>
      </tr>
      <tr className="border px-4 py-2 mt-2">
        <td className="px-4 py-2 font-bold text-gray-600">Your Three Strengths:</td>
        <td className="px-4 py-2">{user?.additionalInformationId?.Three_Strengths}</td>
      </tr>
      <tr className="border px-4 py-2 mt-2">
        <td className="px-4 py-2 font-bold text-gray-600">Are you willing to travel:</td>
        <td className="px-4 py-2">
          <div className="flex space-x-10">
            <div>
              <strong className="text-gray-600 font-bold">In India:</strong> {user?.additionalInformationId?.In_India}
            </div>
            <div>
              <strong className="text-gray-600 font-bold">Abroad:</strong> {user?.additionalInformationId?.Abroad}
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>





      {/* Documents */}
      <div className="card bg-white p-6 mb-6 rounded-lg shadow-md">
      

        <div className=" flex justify-between ">
  <h2 className="text-xl font-semibold text-blue-600 mb-4">Documents</h2>
  {cookies.role !== "67f7d873fa852258bf9a2112" && (
  <button onClick={()=>deleteDocments(user?.DocumentsId._id)}   className="bg-red-500 text-white px-4 py-1 mb-4 ml-4 rounded-md justify-end"
   >Delete</button>
  )}
  </div>








        <div className="mt-6 sm:text-xs md:text-xs xl:text-xs lg:text-sm 2xl:text-lg">
  <h3 className="text-lg font-bold mb-2">Documents</h3>



  <table className="table-auto w-full">
    <thead className="text-xs">
      <tr>
        <th className="border px-2 py-2">Aadhar Card</th>
        <th className="border px-2 py-2">PAN Card</th>
        <th className="border px-2 py-2">Latest Salary Slip</th>
        <th className="border px-2 py-2">Resignation Letter</th>
        <th className="border px-2 py-2">Appointment Letter</th>
        <th className="border px-2 py-2">Offer Letter</th>
        <th className="border px-2 py-2">Bank Statement</th>
        <th className="border px-2 py-2">10th Marksheet</th>
        <th className="border px-2 py-2">12th Marksheet</th>
        <th className="border px-2 py-2">Graduation Marksheet</th>
        <th className="border px-2 py-2">Passport/Voter ID</th>
       
      </tr>
    </thead>
    <tbody>
      <tr className="sm:text-xs md:text-sm xl:text-sm lg:text-sm 2xl:text-lg">
        
        
      <td className="border px-2 py-2">
  {user?.DocumentsId?.adharCard ? (
    <div>
      {user.DocumentsId.adharCard.endsWith(".pdf") ? (
        <embed
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId.adharCard.replace("UserDocument/","")}`}
          type="application/pdf"
          style={{ width: "80px", height: "80px" }}
          alt="Aadhar Card"
        />
      ) : (
        <img
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId.adharCard.replace("UserDocument/","")}`}
          style={{ width: "80px", height: "80px" }}
          alt="Aadhar Card"
        />
      )}
      <div className="flex gap-2 mt-2">
        <a
          href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId.adharCard.replace("UserDocument/","")}`}
          download
        >
          <GrView className="text-blue-500 ml-2" />
        </a>
        <a
          className="text-blue-500 mx-2"
          onClick={() =>
            downloadImage(
              ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId.adharCard.replace("UserDocument/","")}`,
              `adharCard_${user?.DocumentsId.adharCard.replace(/[^a-zA-Z0-9]/g, "_")}`
            )
          }
        >
          <MdDownload />
        </a>
       <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("adharCard", user?._id)}
>
  <MdDelete />
</div>


      </div>
     
    </div>
  ) : (
    <span>No document</span>
  )}
</td>



<td className="border px-2 py-2">
  {user?.DocumentsId?.panCard ? (
    <div>
      {user.DocumentsId.panCard.endsWith(".pdf") ? (
        <embed
          src={`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.panCard.replace("UserDocument/","")}`}
          type="application/pdf"
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      ) : (
        <img
          src={`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.panCard.replace("UserDocument/","")}`}
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      )}
      <div className="flex gap-2 mt-2">
        <a
          href={`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.panCard.replace("UserDocument/","")}`}
          download
        >
          <GrView className="text-blue-500 ml-2" />
        </a>
        <a
          className="text-blue-500 mx-2"
          onClick={() =>
            downloadImage(
              `http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.panCard.replace("UserDocument/","")}`,
              `panCard_${user.DocumentsId.panCard.replace(/[^a-zA-Z0-9]/g, "_")}`
            )
          }
        >
          <MdDownload />
        </a>
        <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("panCard", user?._id)}
>
  <MdDelete />
</div>

      </div>
    </div>
  ) : (
    <span>No document</span>
  )}
</td>



        <td className="border px-2 py-2">
          {user.DocumentsId?.Latest_Salary_Slip ? (
            <div>
              {user.DocumentsId?.Latest_Salary_Slip.endsWith(".pdf") ? (
                <embed
                  src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Latest_Salary_Slip.replace("UserDocument/","")}`}
                  type="application/pdf"
                  style={{ width: "80px", height: "80px" }}
                  alt="Latest Salary Slip"
                />
              ) : (
                <img
                  src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId?.Latest_Salary_Slip.replace("UserDocument/","")}`}
                  style={{ width: "80px", height: "80px" }}
                  alt="Latest Salary Slip"
                />
              )}
              <div className="flex gap-2 mt-2">
                <a
                  href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId?.Latest_Salary_Slip.replace("UserDocument/","")}`}
                  download
                >
                  <GrView className="text-blue-500 ml-2" />
                </a>
                <a
                  className="text-blue-500 mx-2"
                  onClick={() =>
                    downloadImage(
                      ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId?.Latest_Salary_Slip.replace("UserDocument/","")}`,
                      `Latest_Salary_Slip_${user.DocumentsId?.Latest_Salary_Slip.replace(/[^a-zA-Z0-9]/g, "_")}`
                    )
                  }
                >
                  <MdDownload />
                </a>
                 <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("Latest_Salary_Slip", user?._id)}
>
  <MdDelete />
</div>
              </div>
            </div>
          ) : (
            <span>No document</span>
          )}
        </td>

        <td className="border px-2 py-2">
          {user.DocumentsId?.Resiganation_Letter_Of_Current ? (
            <div>
              {user.DocumentsId?.Resiganation_Letter_Of_Current.endsWith(".pdf") ? (
                <embed
                  src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId?.Resiganation_Letter_Of_Current.replace("UserDocument/","")}`}
                  type="application/pdf"
                  style={{ width: "80px", height: "80px" }}
                  alt="Resignation Letter"
                />
              ) : (
                <img
                  src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId?.Resiganation_Letter_Of_Current.replace("UserDocument/","")}`}
                  style={{ width: "80px", height: "80px" }}
                  alt="Resignation Letter"
                />
              )}
              <div className="flex gap-2 mt-2">
                <a
                  href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId?.Resiganation_Letter_Of_Current.replace("UserDocument/","")}`}
                  download
                >
                  <GrView className="text-blue-500 ml-2" />
                </a>
                <a
                  className="text-blue-500 mx-2"
                  onClick={() =>
                    downloadImage(
                      ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId?.Resiganation_Letter_Of_Current.replace("UserDocument/","")}`,
                      `Resiganation_Letter_Of_Current_${user.DocumentsId?.Resiganation_Letter_Of_Current.replace(/[^a-zA-Z0-9]/g, "_")}`
                    )
                  }
                >
                  <MdDownload />
                </a>
                 <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("Resiganation_Letter_Of_Current", user?._id)}
>
  <MdDelete />
</div>
              </div>
            </div>
          ) : (
            <span>No document</span>
          )}
        </td>

       

<td className="border px-2 py-2">
  {user?.DocumentsId?.Appointment_Letter_Of_Current ? (
    <div>
      {user.DocumentsId.Appointment_Letter_Of_Current.endsWith(".pdf") ? (
        <embed
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Appointment_Letter_Of_Current.replace("UserDocument/","")}`}
          type="application/pdf"
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      ) : (
        <img
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Appointment_Letter_Of_Current.replace("UserDocument/","")}`}
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      )}
      <div className="flex gap-2 mt-2">
        <a
          href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Appointment_Letter_Of_Current.replace("UserDocument/","")}`}
          download
        >
          <GrView className="text-blue-500 ml-2" />
        </a>
        <a
          className="text-blue-500 mx-2"
          onClick={() =>
            downloadImage(
              ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Appointment_Letter_Of_Current.replace("UserDocument/","")}`,
              `Appointment_Letter_Of_Current_${user.DocumentsId.Appointment_Letter_Of_Current.replace(/[^a-zA-Z0-9]/g, "_")}`
            )
          }
        >
          <MdDownload />
        </a>
       <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("Appointment_Letter_Of_Current", user?._id)}
>
  <MdDelete />
</div>
      </div>
    </div>
  ) : (
    <span>No document</span>
  )}
</td>



<td className="border px-2 py-2">
  {user?.DocumentsId?.Offer_Letter_with_DOJ_and_salary_bifurcation ? (
    <div>
      {user.DocumentsId.Offer_Letter_with_DOJ_and_salary_bifurcation.endsWith(".pdf") ? (
        <embed
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Offer_Letter_with_DOJ_and_salary_bifurcation.replace("UserDocument/","")}`}
          type="application/pdf"
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      ) : (
        <img
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Offer_Letter_with_DOJ_and_salary_bifurcation.replace("UserDocument/","")}`}
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      )}
      <div className="flex gap-2 mt-2">
        <a
          href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Offer_Letter_with_DOJ_and_salary_bifurcation.replace("UserDocument/","")}`}
          download
        >
          <GrView className="text-blue-500 ml-2" />
        </a>
        <a
          className="text-blue-500 mx-2"
          onClick={() =>
            downloadImage(
              ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Offer_Letter_with_DOJ_and_salary_bifurcation.replace("UserDocument/","")}`,
              `Offer_Letter_with_DOJ_and_salary_bifurcation_${user.DocumentsId.Offer_Letter_with_DOJ_and_salary_bifurcation.replace(/[^a-zA-Z0-9]/g, "_")}`
            )
          }
        >
          <MdDownload />
        </a>
        <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("Offer_Letter_with_DOJ_and_salary_bifurcation", user?._id)}
>
  <MdDelete />
</div>
      </div>
    </div>
  ) : (
    <span>No document</span>
  )}
</td>

<td className="border px-2 py-2">
  {user?.DocumentsId?.Bank_Statement_of_Salary_account ? (
    <div>
      {user.DocumentsId.Bank_Statement_of_Salary_account.endsWith(".pdf") ? (
        <embed
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Bank_Statement_of_Salary_account.replace("UserDocument/","")}`}
          type="application/pdf"
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      ) : (
        <img
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Bank_Statement_of_Salary_account.replace("UserDocument/","")}`}
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      )}
      <div className="flex gap-2 mt-2">
        <a
          href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Bank_Statement_of_Salary_account.replace("UserDocument/","")}`}
          download
        >
          <GrView className="text-blue-500 ml-2" />
        </a>
        <a
          className="text-blue-500 mx-2"
          onClick={() =>
            downloadImage(
              ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Bank_Statement_of_Salary_account.replace("UserDocument/","")}`,
              `Bank_Statement_of_Salary_account_${user.DocumentsId.Bank_Statement_of_Salary_account.replace(/[^a-zA-Z0-9]/g, "_")}`
            )
          }
        >
          <MdDownload />
        </a>
        <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("Bank_Statement_of_Salary_account", user?._id)}
>
  <MdDelete />
</div>
      </div>
    </div>
  ) : (
    <span>No document</span>
  )}
</td>

<td className="border px-2 py-2">
  {user?.DocumentsId?.Marksheet_of_10th ? (
    <div>
      {user.DocumentsId.Marksheet_of_10th.endsWith(".pdf") ? (
        <embed
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Marksheet_of_10th.replace("UserDocument/","")}`}
          type="application/pdf"
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      ) : (
        <img
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Marksheet_of_10th.replace("UserDocument/","")}`}
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      )}
      <div className="flex gap-2 mt-2">
        <a
          href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Marksheet_of_10th.replace("UserDocument/","")}`}
          download
        >
          <GrView className="text-blue-500 ml-2" />
        </a>
        <a
          className="text-blue-500 mx-2"
          onClick={() =>
            downloadImage(
              ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Marksheet_of_10th.replace("UserDocument/","")}`,
              `Marksheet_of_10th_${user.DocumentsId.Marksheet_of_10th.replace(/[^a-zA-Z0-9]/g, "_")}`
            )
          }
        >
          <MdDownload />
        </a>
          <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("Marksheet_of_10th", user?._id)}
>
  <MdDelete />
</div>
      </div>
    </div>
  ) : (
    <span>No document</span>
  )}
</td>

<td className="border px-2 py-2">
  {user?.DocumentsId?.Marksheet_of_12th ? (
    <div>
      {user.DocumentsId.Marksheet_of_12th.endsWith(".pdf") ? (
        <embed
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Marksheet_of_12th.replace("UserDocument/","")}`}
          type="application/pdf"
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      ) : (
        <img
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Marksheet_of_12th.replace("UserDocument/","")}`}
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      )}
      <div className="flex gap-2 mt-2">
        <a
          href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Marksheet_of_12th.replace("UserDocument/","")}`}
          download
        >
          <GrView className="text-blue-500 ml-2" />
        </a>
        <a
          className="text-blue-500 mx-2"
          onClick={() =>
            downloadImage(
              ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Marksheet_of_12th.replace("UserDocument/","")}`,
              `Marksheet_of_12th_${user.DocumentsId.Marksheet_of_12th.replace(/[^a-zA-Z0-9]/g, "_")}`
            )
          }
        >
          <MdDownload />
        </a>
           <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("Marksheet_of_12th", user?._id)}
>
  <MdDelete />
</div>
      </div>
    </div>
  ) : (
    <span>No document</span>
  )}
</td>

<td className="border px-2 py-2">
  {user?.DocumentsId?.Marksheet_of_Graduation ? (
    <div>
      {user.DocumentsId.Marksheet_of_Graduation.endsWith(".pdf") ? (
        <embed
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Marksheet_of_Graduation.replace("UserDocument/","")}`}
          type="application/pdf"
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      ) : (
        <img
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Marksheet_of_Graduation.replace("UserDocument/","")}`}
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      )}
      <div className="flex gap-2 mt-2">
        <a
          href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user.DocumentsId.Marksheet_of_Graduation.replace("UserDocument/","")}`}
          download
        >
          <GrView className="text-blue-500 ml-2" />
        </a>
        <a
          className="text-blue-500 mx-2"
          onClick={() =>
            downloadImage(
              ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Marksheet_of_Graduation.replace("UserDocument/","")}`,
              `Marksheet_of_Graduation_${user.DocumentsId.Marksheet_of_Graduation.replace(/[^a-zA-Z0-9]/g, "_")}`
            )
          }
        >
          <MdDownload />
        </a>
          <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("Marksheet_of_Graduation", user?._id)}
>
  <MdDelete />
</div>
      </div>
    </div>
  ) : (
    <span>No document</span>
  )}
</td>

        <td className="border px-2 py-2">
  {user?.DocumentsId?.Passport_or_Voter_ID ? (
    <div>
      {user.DocumentsId.Passport_or_Voter_ID.endsWith(".pdf") ? (
        <embed
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Passport_or_Voter_ID.replace("UserDocument/","")}`}
          type="application/pdf"
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      ) : (
        <img
          src={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Passport_or_Voter_ID.replace("UserDocument/","")}`}
          style={{ width: "80px", height: "80px" }}
          alt="PAN Card"
        />
      )}
      <div className="flex gap-2 mt-2">
        <a
          href={` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Passport_or_Voter_ID.replace("UserDocument/","")}`}
          download
        >
          <GrView className="text-blue-500 ml-2" />
        </a>
        <a
          className="text-blue-500 mx-2"
          onClick={() =>
            downloadImage(
              ` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/${user?.DocumentsId?.Passport_or_Voter_ID.replace("UserDocument/","")}`,
              `Passport_or_Voter_ID_${user.DocumentsId.Passport_or_Voter_ID.replace(/[^a-zA-Z0-9]/g, "_")}`
            )
          }
        >
          <MdDownload />
        </a>
          <div
  className="text-red-500 mr-2 cursor-pointer"
  onClick={() => deleteWrongDocument("Passport_or_Voter_ID", user?._id)}
>
  <MdDelete />
</div>
      </div>
    </div>
  ) : (
    <span>No document</span>
  )}
</td>



      </tr>
    </tbody>
  </table>


  <div className="mt-11 items-center">
            <th className="border px-2 py-2">HR Contact</th>

            <tr>
                <td className="border px-3 py-3 ">
                      {user.DocumentsId?.Email_ID_and_Contact_of_current_or_previous_HR ? (
                        <div>
                          <span>
                            {
                              user.DocumentsId.Email_ID_and_Contact_of_current_or_previous_HR
                            }
                          </span>
                        </div>
                      ) : (
                        <span>No contact information</span>
                      )}
                    </td>
                </tr>
            </div>
</div>




{cookies.role !== "67f7d873fa852258bf9a2112" && ( 

<div className="p-4 mt-10">
{feedbacks.length === 0 ? (
  <p className="text-gray-500">No feedback found for this user.</p>
) : (
  feedbacks.map((feedback, index) => (
    <div
      key={index}
      className="border p-4 mb-4 rounded-lg shadow-md bg-white"
    >
      <h2 className="text-xl font-bold mb-4 border-b-2 text-center w-1/4 p-2">User Feedback</h2>

      {/* Rating Questions with Stars */}
      <div className="space-y-3 mb-4">
        {[
          "1. How would you rate your overall experience in the role, and how closely did the responsibilities align with the job description shared during the hiring process?",
          "2. How would you rate your interview experience (interviewer professionalism, structure, and clarity)?",
          "3. How easy was it to complete and submit the required documentation?",
          "4. How would you rate your overall pre-boarding experience?"
        ].map((question, i) => {
          const ratingStr = feedback.ratings[i]; // e.g., "5/2"
          const score = parseInt(ratingStr.split("/")[1]); // extract 2 from "5/2"

          return (
            <div key={i}>
              {/* Display the question above the rating */}
              <div className="text-gray-700 font-medium mb-2">{question}</div>
              
              {/* Star Rating */}
              <div className="flex gap-1 mb-2">
                {[...Array(5)].map((_, j) =>
                  j < score ? (
                    <FaStar key={j} className="text-yellow-400 text-lg" />
                  ) : (
                    <FaRegStar key={j} className="text-gray-300 text-lg" />
                  )
                )}
              </div>
              
              {/* Display the description below the rating */}
              <div className="text-gray-700 font-medium border-b w-1/3 mb-4 p-2">
                {feedback.descriptions[i]}
              </div>
            </div>
          );
        })}
      </div>

      {/* Optional Comment Section */}
      {feedback.comment && (
        <div className="mb-2">
          <strong>5. Do you have any suggestions to improve the pre-boarding process?</strong> <br/>
          <span className="text-gray-700">{feedback.comment}</span>
        </div>
      )}

      {/* Suggestion Section */}
      {/* <div className="mb-2">
        <strong></strong> <br/>
        <span className="text-gray-700">{feedback.suggestions || "No suggestions provided."}</span>
      </div> */}

      {/* Submitted Date */}
      <div className="text-sm text-gray-500 italic mt-7">
        Submitted on: {new Date(feedback.createdAt).toLocaleString()}
      </div>
    </div>
  ))
)}
</div>




)}

       
      </div>
    </div>
  );
};

export default CandidateDetailPage;
